import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ShieldCheck, ArrowRight, ArrowLeft } from 'lucide-react';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { api } from '@/lib/api';
import { toast } from 'sonner';

export default function AdminLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await api.post('/auth/login', { email, password });
      localStorage.setItem('cq_admin_token', res.data.token);
      localStorage.setItem('cq_admin_user', JSON.stringify(res.data.user));
      toast.success('Welcome back, Admin');
      navigate('/admin');
    } catch (err) {
      const detail = err?.response?.data?.detail;
      toast.error(typeof detail === 'string' ? detail : 'Login failed. Please check credentials.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen gradient-bg grain flex items-center justify-center px-5">
      <div className="max-w-md w-full">
        <Link to="/" data-testid="admin-back-home" className="flex items-center gap-2 text-sm font-bold text-muted-ink hover:text-ink mb-6">
          <ArrowLeft className="w-4 h-4" strokeWidth={3} /> Back to Career Fit Assessment
        </Link>
        <motion.div initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} className="card-soft p-7 sm:p-9">
          <div className="w-14 h-14 rounded-2xl bg-[#0055FF] text-white flex items-center justify-center">
            <ShieldCheck className="w-7 h-7" strokeWidth={2.5} />
          </div>
          <h1 className="font-display font-black text-ink text-3xl mt-5 tracking-tight">Admin Console</h1>
          <p className="text-sm text-muted-ink mt-1">Sign in to view Career Fit Assessment leads and results.</p>

          <form onSubmit={submit} className="mt-7 space-y-4" data-testid="admin-login-form">
            <div>
              <Label className="text-xs uppercase tracking-[0.2em] font-bold text-muted-ink">Email</Label>
              <Input data-testid="admin-email-input" type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="admin@futureready.school" className="mt-2 h-12 rounded-2xl" />
            </div>
            <div>
              <Label className="text-xs uppercase tracking-[0.2em] font-bold text-muted-ink">Password</Label>
              <Input data-testid="admin-password-input" type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" className="mt-2 h-12 rounded-2xl" />
            </div>
            <button type="submit" data-testid="admin-submit-button" disabled={loading} className="btn-primary w-full inline-flex items-center justify-center gap-2 disabled:opacity-60">
              {loading ? 'Signing in…' : (<>Sign in <ArrowRight className="w-4 h-4" strokeWidth={3} /></>)}
            </button>
          </form>
        </motion.div>
      </div>
    </div>
  );
}
